import { render, staticRenderFns } from "./hobbyItem.vue?vue&type=template&id=dd11d8e2&scoped=true"
import script from "./hobbyItem.vue?vue&type=script&lang=ts"
export * from "./hobbyItem.vue?vue&type=script&lang=ts"
import style0 from "./hobbyItem.vue?vue&type=style&index=0&id=dd11d8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd11d8e2",
  null
  
)

export default component.exports